import React from 'react';
import {useLocation, Navigate} from 'react-router-dom';
import {useMutation} from '@apollo/client';
import {useIntercom} from 'react-use-intercom';

import {getErrorMessage} from '@sphericsio/mvp-ui-common';

import {GetCurrentUserDocument} from '../../components/user-context';
import {FullScreenError, FullScreenLoading} from '../../components/full-screen';
import {graphql} from '../../graphql/generated';

export const IdentityProviderCallbackDocument = graphql(/* GraphQL */ `
    mutation IdentityProviderCallback($params: String!, $provider: IdentityProviderName!) {
        identityProviderCallback(params: $params, provider: $provider) {
            id
        }
    }
`);

const IDENTITY_PROVIDER = 'sageid';
export function IdentityProviderCallback() {
    const location = useLocation();
    const {trackEvent} = useIntercom();
    const [preMutation, setPreMutation] = React.useState(true);
    const [providerCallback, {loading, error, data}] = useMutation(
        IdentityProviderCallbackDocument,
    );

    React.useLayoutEffect(() => {
        providerCallback({
            variables: {
                params: `${location.pathname}${location.search}`,
                provider: IDENTITY_PROVIDER,
            },
            refetchQueries: [{query: GetCurrentUserDocument}],
            awaitRefetchQueries: true,
        });
        setPreMutation(false);
    }, []);

    React.useEffect(() => {
        if (data?.identityProviderCallback) {
            trackEvent('User account created');
        }
    }, [data?.identityProviderCallback]);

    const defaultMessage = `An error occurred whilst switching you to ${IDENTITY_PROVIDER}. Please try again later`;
    const errorMessage = React.useMemo(() => {
        if (error) {
            return getErrorMessage(error, {defaultMessage});
        }
    }, [error]);

    if (loading || preMutation) {
        return <FullScreenLoading />;
    }

    if (error) {
        return <FullScreenError message={errorMessage} error={error} buttonHref="/login" />;
    }

    return <Navigate to="/" />;
}
